import {IPositionSingleVoyage} from "@containers/singleVoyage/types/position";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {IRouteInfoSingleVoyage} from "@containers/singleVoyage/types/route";
import {ISingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
    getInitialRouteInfoMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/helpers/getInitialRouteInfoMutateSingleVoyage";
import {routeShapeToPositionsSingleVoyage} from "@containers/singleVoyage/helpers/routeShape/routeShapeToPositions";
import {getRouteInfoFromSingleVoyage} from "@containers/singleVoyage/helpers/routeInfo/getRouteInfoFromSingleVoyage";
import {
    getInitialWaypointsCreationWithCorrectionsSingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/getInitialWaypointsCreationWithCorrections";

export const getInitialMutateVoyagePropsFromSingleVoyage = (voyage?: ISingleVoyage): {
    initialPositions: IPositionSingleVoyage[],
    initialPoints: IWayPointCreationWithCorrectionsSingleVoyage[],
    initialRouteInfo: IRouteInfoSingleVoyage,
} => {
    if (!voyage) {
        return {
            initialPositions: [],
            initialPoints: [],
            initialRouteInfo: getInitialRouteInfoMutateSingleVoyage()
        }
    }
    return {
        initialPositions: routeShapeToPositionsSingleVoyage(voyage.routeShape),
        initialPoints: getInitialWaypointsCreationWithCorrectionsSingleVoyage(voyage.waypoints),
        initialRouteInfo: getRouteInfoFromSingleVoyage(voyage)

    }
}
